import React from "react";
import { Typography, Paper, useTheme } from "@mui/material";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

function DeploymentsPerMonthChart({ data }) {
  const theme = useTheme();
  return (
    <Paper
      style={{ backgroundColor: theme.palette.success.main }}
      elevation={3}
      sx={{ padding: 2 }}
    >
      <Typography color={theme.palette.success.text} variant="h6" gutterBottom>
        Deployments per Month
      </Typography>
      <ResponsiveContainer width="100%" height={300}>
        <LineChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Line type="monotone" dataKey="deployments" stroke="#FF8300" />
        </LineChart>
      </ResponsiveContainer>
    </Paper>
  );
}

export default DeploymentsPerMonthChart;
